import { render, staticRenderFns } from "./TrendArrow.vue?vue&type=template&id=1ac509bc&"
import script from "./TrendArrow.vue?vue&type=script&lang=js&"
export * from "./TrendArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports